const workOptions = {
  '1': [
    {
      value: '',
      label: 'competitions.inputs.wrk_name',
      key: 'wrk_name',
      length: 45,
      type: 'String'
    },
    {
      value: '',
      label: 'competitions.inputs.wrk_author',
      key: 'wrk_author',
      length: 255,
      type: 'String'
    },
    {
      value: '',
      label: 'competitions.inputs.wrk_parent',
      key: 'wrk_parent',
      length: 255,
      type: 'String'
    },
    {
      value: '',
      label: 'competitions.inputs.wrk_phone_number',
      key: 'wrk_phone_number',
      length: 255,
      type: 'String'
    },
    {
      value: '',
      label: 'competitions.inputs.wrk_region',
      key: 'wrk_region',
      length: 255,
      type: 'String'
    },
    {
      value: '',
      label: 'competitions.inputs.wrk_postal_code',
      key: 'wrk_postal_code',
      length: 255,
      type: 'String'
    },
    {
      value: '',
      label: 'competitions.inputs.wrk_address',
      key: 'wrk_address',
      length: 255,
      type: 'String'
    },
    {
      value: '',
      label: 'competitions.inputs.wrk_email',
      key: 'wrk_email',
      length: 255,
      type: 'String'
    },
    {
      value: '',
      label: 'competitions.inputs.wrk_sponsor_name',
      key: 'wrk_sponsor_name',
      length: 255,
      type: 'String'
    },
    {
      value: '',
      label: 'competitions.inputs.wrk_sponsor_link',
      key: 'wrk_sponsor_link',
      length: 255,
      type: 'String'
    },
    {
      value: 'school',
      label: 'competitions.inputs.school',
      key: 'school',
      length: 255,
      type: 'String'
    },
    {
      value: '',
      label: 'competitions.inputs.sch_region',
      key: 'sch_region',
      length: 255,
      type: 'String',
      disabled: true
    },
    {
      value: '',
      label: 'competitions.inputs.sch_address',
      key: 'sch_address',
      length: 255,
      type: 'String',
      disabled: true
    },
    {
      value: '',
      label: 'competitions.inputs.wrk_class1',
      key: 'wrk_class',
      length: 10,
      type: 'String'
    }
  ],
  '2': [
    {
      value: '',
      label: 'competitions.inputs.wrk_name',
      key: 'wrk_name',
      length: 45,
      type: 'String'
    },
    {
      value: '',
      label: 'competitions.inputs.wrk_author',
      key: 'wrk_author',
      length: 255,
      type: 'String'
    },
    {
      value: '',
      label: 'competitions.inputs.wrk_parent',
      key: 'wrk_parent',
      length: 255,
      type: 'String'
    },
    {
      value: '',
      label: 'competitions.inputs.wrk_phone_number',
      key: 'wrk_phone_number',
      length: 255,
      type: 'String'
    },
    {
      value: '',
      label: 'competitions.inputs.wrk_region',
      key: 'wrk_region',
      length: 255,
      type: 'String'
    },
    {
      value: '',
      label: 'competitions.inputs.wrk_postal_code',
      key: 'wrk_postal_code',
      length: 255,
      type: 'String'
    },
    {
      value: '',
      label: 'competitions.inputs.wrk_address',
      key: 'wrk_address',
      length: 255,
      type: 'String'
    },
    {
      value: '',
      label: 'competitions.inputs.wrk_email',
      key: 'wrk_email',
      length: 255,
      type: 'String'
    },
    {
      value: '',
      label: 'competitions.inputs.wrk_sponsor_name',
      key: 'wrk_sponsor_name',
      length: 255,
      type: 'String'
    },
    {
      value: '',
      label: 'competitions.inputs.wrk_sponsor_link',
      key: 'wrk_sponsor_link',
      length: 255,
      type: 'String'
    },
    {
      value: 'school',
      label: 'competitions.inputs.school',
      key: 'school',
      length: 255,
      type: 'String'
    },
    {
      value: '',
      label: 'competitions.inputs.sch_region',
      key: 'sch_region',
      length: 255,
      type: 'String',
      disabled: true
    },
    {
      value: '',
      label: 'competitions.inputs.sch_address',
      key: 'sch_address',
      length: 255,
      type: 'String',
      disabled: true
    },
    {
      value: '',
      label: 'competitions.inputs.wrk_class2',
      key: 'wrk_class',
      length: 10,
      type: 'String'
    }
  ],
  '3': [
    {
      value: '',
      label: 'competitions.inputs.wrk_name',
      key: 'wrk_name',
      length: 45,
      type: 'String'
    },
    {
      value: '',
      label: 'competitions.inputs.wrk_author',
      key: 'wrk_author',
      length: 255,
      type: 'String'
    },
    {
      value: '',
      label: 'competitions.inputs.wrk_parent',
      key: 'wrk_parent',
      length: 255,
      type: 'String'
    },
    {
      value: '',
      label: 'competitions.inputs.wrk_phone_number',
      key: 'wrk_phone_number',
      length: 255,
      type: 'String'
    },
    {
      value: '',
      label: 'competitions.inputs.wrk_region',
      key: 'wrk_region',
      length: 255,
      type: 'String'
    },
    {
      value: '',
      label: 'competitions.inputs.wrk_postal_code',
      key: 'wrk_postal_code',
      length: 255,
      type: 'String'
    },
    {
      value: '',
      label: 'competitions.inputs.wrk_address',
      key: 'wrk_address',
      length: 255,
      type: 'String'
    },
    {
      value: '',
      label: 'competitions.inputs.wrk_email',
      key: 'wrk_email',
      length: 255,
      type: 'String'
    },
    {
      value: '',
      label: 'competitions.inputs.wrk_sponsor_name',
      key: 'wrk_sponsor_name',
      length: 255,
      type: 'String'
    },
    {
      value: '',
      label: 'competitions.inputs.wrk_sponsor_link',
      key: 'wrk_sponsor_link',
      length: 255,
      type: 'String'
    },
    {
      value: 'school',
      label: 'competitions.inputs.school',
      key: 'school',
      length: 255,
      type: 'String'
    },
    {
      value: '',
      label: 'competitions.inputs.sch_region',
      key: 'sch_region',
      length: 255,
      type: 'String',
      disabled: true
    },
    {
      value: '',
      label: 'competitions.inputs.sch_address',
      key: 'sch_address',
      length: 255,
      type: 'String',
      disabled: true
    },
    {
      value: '',
      label: 'competitions.inputs.wrk_class1',
      key: 'wrk_class',
      length: 10,
      type: 'String'
    }
  ],
  '4': [
    {
      value: '',
      label: 'competitions.inputs.wrk_name',
      key: 'wrk_name',
      length: 45,
      type: 'String'
    },
    {
      value: '',
      label: 'competitions.inputs.wrk_author',
      key: 'wrk_author',
      length: 255,
      type: 'String'
    },
    {
      value: '',
      label: 'competitions.inputs.wrk_parent',
      key: 'wrk_parent',
      length: 255,
      type: 'String'
    },
    {
      value: '',
      label: 'competitions.inputs.wrk_phone_number',
      key: 'wrk_phone_number',
      length: 255,
      type: 'String'
    },
    {
      value: '',
      label: 'competitions.inputs.wrk_region',
      key: 'wrk_region',
      length: 255,
      type: 'String'
    },
    {
      value: '',
      label: 'competitions.inputs.wrk_postal_code',
      key: 'wrk_postal_code',
      length: 255,
      type: 'String'
    },
    {
      value: '',
      label: 'competitions.inputs.wrk_address',
      key: 'wrk_address',
      length: 255,
      type: 'String'
    },
    {
      value: '',
      label: 'competitions.inputs.wrk_email',
      key: 'wrk_email',
      length: 255,
      type: 'String'
    },
    {
      value: '',
      label: 'competitions.inputs.wrk_sponsor_name',
      key: 'wrk_sponsor_name',
      length: 255,
      type: 'String'
    },
    {
      value: '',
      label: 'competitions.inputs.wrk_sponsor_link',
      key: 'wrk_sponsor_link',
      length: 255,
      type: 'String'
    }
  ]
}

export { workOptions }
